(() => {
  const NOTE_YES = 'BOLSAS SEPARADAS: SÍ';
  const NOTE_NO = 'BOLSAS SEPARADAS: NO';
  const NOTE_PATTERN = /BOLSAS SEPARADAS:\s*(?:SÍ|SI|NO)\s*/gi;

  const DRAWER_SELECTOR = [
    'cart-drawer',
    '[data-cart-drawer]',
    '#cart-drawer',
    '.cart-drawer',
    '.drawer--cart',
    '[data-drawer="cart"]'
  ].join(',');

  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href$="/checkout"]',
    'a[href*="/checkout?"]'
  ].join(',');

  const CART_ROOT = window.Shopify?.routes?.root || '/';

  let cartNote = '';
  let selectedValue = null;
  let isSaving = false;

  const createComponent = () => {
    const component = document.createElement('div');

    component.className = 'cm-bags';
    component.setAttribute('data-cm-bags', '');

    component.innerHTML = `
      <div class="cm-bags__title">
        ¿Deseas que cada producto sea empacado en una bolsa separada?
      </div>

      <div class="cm-bags__options">
        <label class="cm-bags__option">
          <input
            type="radio"
            name="cmSeparateBags"
            value="yes"
            data-cm-bags-input
          >
          <span>Sí</span>
        </label>

        <label class="cm-bags__option">
          <input
            type="radio"
            name="cmSeparateBags"
            value="no"
            data-cm-bags-input
          >
          <span>No</span>
        </label>
      </div>

      <div class="cm-bags__message" data-cm-bags-message>
        Selecciona una opción para continuar.
      </div>
    `;

    return component;
  };

  const getCheckoutButtons = () => {
    return [...document.querySelectorAll(DRAWER_SELECTOR)]
      .flatMap(drawer => [...drawer.querySelectorAll(CHECKOUT_SELECTOR)]);
  };

  const updateCheckoutState = () => {
    const valid = selectedValue !== null && !isSaving;

    getCheckoutButtons().forEach(button => {
      if (button.tagName === 'A') {
        button.style.pointerEvents = valid ? '' : 'none';
        button.setAttribute('aria-disabled', valid ? 'false' : 'true');

        if (!valid) {
          button.setAttribute('data-cm-disabled', '');
        } else {
          button.removeAttribute('data-cm-disabled');
        }
      } else {
        button.disabled = !valid;
      }
    });

    document.querySelectorAll('[data-cm-bags-message]').forEach(message => {
      if (isSaving) {
        message.textContent = 'Guardando...';
      } else if (selectedValue === null) {
        message.textContent = 'Selecciona una opción para continuar.';
      } else {
        message.textContent = '';
      }
    });
  };

  const syncRadios = () => {
    document.querySelectorAll('[data-cm-bags-input]').forEach(input => {
      input.checked = input.value === selectedValue;
      input.disabled = isSaving;
    });

    updateCheckoutState();
  };

  const cleanPackagingNote = note => {
    return (note || '')
      .replace(NOTE_PATTERN, '')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  };

  const buildCartNote = value => {
    const existingNote = cleanPackagingNote(cartNote);
    const packagingNote = value === 'yes' ? NOTE_YES : NOTE_NO;

    return existingNote
      ? `${packagingNote}\n\n${existingNote}`
      : packagingNote;
  };

  const injectComponent = () => {
    document.querySelectorAll(DRAWER_SELECTOR).forEach(drawer => {
      if (drawer.querySelector('[data-cm-bags]')) return;

      const checkoutButton = drawer.querySelector(CHECKOUT_SELECTOR);

      if (!checkoutButton) return;

      const checkoutContainer =
        checkoutButton.closest(
          '.cart__buttons, .cart__checkout, [data-cart-checkout]'
        ) || checkoutButton;

      checkoutContainer.insertAdjacentElement(
        'beforebegin',
        createComponent()
      );
    });

    syncRadios();
  };

  const loadCartState = async () => {
    try {
      const response = await fetch(`${CART_ROOT}cart.js`, {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();

      cartNote = cart.note || '';

      if (/BOLSAS SEPARADAS:\s*(?:SÍ|SI)/i.test(cartNote)) {
        selectedValue = 'yes';
      } else if (/BOLSAS SEPARADAS:\s*NO/i.test(cartNote)) {
        selectedValue = 'no';
      } else {
        selectedValue = null;
      }

      syncRadios();
    } catch (error) {
      console.error(error);
    }
  };

  const saveSelection = async value => {
    const previousValue = selectedValue;
    const previousNote = cartNote;

    selectedValue = value;
    isSaving = true;

    syncRadios();

    try {
      const newNote = buildCartNote(value);

      const response = await fetch(`${CART_ROOT}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          note: newNote
        })
      });

      if (!response.ok) {
        throw new Error('No se pudo guardar la selección.');
      }

      const cart = await response.json();

      cartNote = cart.note || newNote;
    } catch (error) {
      selectedValue = previousValue;
      cartNote = previousNote;

      console.error(error);

      document.querySelectorAll('[data-cm-bags-message]').forEach(message => {
        message.textContent = 'No pudimos guardar tu selección. Intenta nuevamente.';
      });
    } finally {
      isSaving = false;
      syncRadios();
    }
  };

  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cm-bags-input]');

    if (!input) return;

    saveSelection(input.value);
  });

  document.addEventListener('click', event => {
    const checkoutButton = event.target.closest(CHECKOUT_SELECTOR);

    if (!checkoutButton) return;

    const drawer = checkoutButton.closest(DRAWER_SELECTOR);

    if (!drawer) return;

    if (selectedValue === null || isSaving) {
      event.preventDefault();
      event.stopPropagation();

      const component = drawer.querySelector('[data-cm-bags]');

      if (component) {
        component.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  }, true);

  const observer = new MutationObserver(() => {
    injectComponent();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  const init = () => {
    injectComponent();
    loadCartState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();